import Papa from 'papaparse'
import type { MerchantRow } from '../domain/merchant'

const sanitize = (value: unknown): unknown => {
  if (typeof value !== 'string') return value
  return /^[=+@]/.test(value) || (/^-/.test(value) && !/^-\d+(?:[.,]\d+)?$/.test(value)) ? `'${value}` : value
}

export function buildMerchantIssueReport(rows: MerchantRow[]): string {
  const output = rows.flatMap((row) => row.issues.map((issue) => ({
    'Source row': row.sourceRowNumber,
    ID: sanitize(row.id),
    Title: sanitize(row.title),
    Severity: issue.severity,
    Field: issue.field ?? '',
    Code: issue.code,
    Problem: issue.message,
    Recommendation: issue.recommendation,
  })))
  return `\uFEFF${Papa.unparse(output, { newline: '\r\n' })}`
}

export function buildMerchantEligibleRows(rows: MerchantRow[]): string {
  const output = rows.filter((row) => row.status !== 'error').map((row) =>
    Object.fromEntries(Object.entries(row.raw).map(([key, value]) => [key, sanitize(value)])),
  )
  return `\uFEFF${Papa.unparse(output, { newline: '\r\n' })}`
}
